import { useMemo } from "react";
import debounce from "lodash.debounce";

export const useDebouncedSearch = (handleSearch, delay = 500) => {
  /* Utilizamos debounce para detener multiples peticiones
        a la API al momento de escribir en el buscador*/
  const debouncedResults = useMemo(() => {
    return debounce(handleSearch, delay);
    // eslint-disable-next-line  react-hooks/exhaustive-deps
  }, []);
  return [debouncedResults];
};
